export default "__VITE_ASSET__COmlAbi0__"